var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button",attrs:{"data-action":"back_process"},on:{"click":_vm.back}},[_c('i',{staticClass:"fa-sharp fa-regular fa-angle-left fa-sm"}),_vm._v(" "+_vm._s(_vm.translate('login-btn-back')))])}
var staticRenderFns = []

export { render, staticRenderFns }